import requestApi from '../../../utils/Request';
import { showErrorAlert, showSuccessAlert } from '../../../utils/AlertUtils';
import {
  requestPriceStrategyList,
  responsePriceStrategyList,
  failurePriceStrategyList,
  requestPriceStrategyAdd,
  responsePriceStrategyAdd,
  failurePriceStrategyAdd,
  requestPriceStrategyView,
  responsePriceStrategyView,
  failurePriceStrategyView,
  requestPriceStrategyDelete,
  responsePriceStrategyDelete,
  failurePriceStrategyDelete,
  requestPriceStrategySync,
  responsePriceStrategySync,
  failurePriceStrategySync,
  requestAssignMerchants,
  responseAssignMerchants,
  failureAssignMerchants,
} from '../../slices/priceStrategySlice/priceStrategySlice';
import {
  PRICE_STRATEGY,
  PRICE_STRATEGY_MIGRATE_MERCHANTS,
} from 'utils/StaticApiEndpoints';

///////// List Price Strategy Data //////////
export const ListPriceStrategyData = (payload = {}) => {
  return (dispatch) => {
    const {
      page = 1,
      limit = 10,
      search = '',
      sortKey = '',
      sortBy = 1,
    } = payload;

    dispatch(requestPriceStrategyList());

    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (search) params.append('search', search);
    if (sortKey) params.append('sortKey', sortKey);
    if (sortBy !== undefined && sortBy !== '')
      params.append('sortBy', sortBy.toString());

    // API integration:
    requestApi
      .get(`${PRICE_STRATEGY}?${params.toString()}`)
      .then((response) => {
        // Handle the response structure: { success: true, data: { list: [], total: 0, ... } }
        dispatch(responsePriceStrategyList(response));
      })
      .catch((error) => {
        dispatch(failurePriceStrategyList(error));
        showErrorAlert(error?.message || 'Failed to load price strategies');
      });
  };
};

///////// Add Price Strategy Data //////////
export const AddPriceStrategyData = (payload, navigate, callback) => {
  return (dispatch) => {
    dispatch(requestPriceStrategyAdd());
    requestApi
      .post(PRICE_STRATEGY, payload)
      .then(() => {
        dispatch(responsePriceStrategyAdd());
        showSuccessAlert('Price strategy added successfully');
        if (navigate) navigate('/admin/price-strategy');
        if (callback) callback();
      })
      .catch((error) => {
        dispatch(failurePriceStrategyAdd(error));
        showErrorAlert(error?.message || 'Failed to add price strategy');
      });
  };
};

///////// View Price Strategy Data //////////
export const ViewPriceStrategyData = (id) => {
  return (dispatch) => {
    dispatch(requestPriceStrategyView());
    requestApi
      .get(`${PRICE_STRATEGY}/${id}`)
      .then((response) => {
        dispatch(responsePriceStrategyView(response));
      })
      .catch((error) => {
        dispatch(failurePriceStrategyView(error));
        showErrorAlert(
          error?.message || 'Failed to load price strategy details',
        );
      });
  };
};

///////// Update Price Strategy Data //////////
export const UpdatePriceStrategyData = (id, payload, navigate, callback) => {
  return (dispatch) => {
    dispatch(requestPriceStrategyAdd());
    requestApi
      .put(`${PRICE_STRATEGY}/${id}`, payload)
      .then(() => {
        dispatch(responsePriceStrategyAdd());
        showSuccessAlert('Price strategy updated successfully');
        if (navigate) navigate('/admin/price-strategy');
        if (callback) callback();
      })
      .catch((error) => {
        dispatch(failurePriceStrategyAdd(error));
        showErrorAlert(error?.message || 'Failed to update price strategy');
      });
  };
};

///////// Delete Price Strategy Data //////////
export const DeletePriceStrategyData = (id, _payload = {}, callback) => {
  return (dispatch) => {
    dispatch(requestPriceStrategyDelete());
    requestApi
      .delete(`${PRICE_STRATEGY}/${id}`)
      .then(() => {
        dispatch(responsePriceStrategyDelete());
        showSuccessAlert('Price strategy deleted successfully');
        if (callback) callback();
      })
      .catch((error) => {
        dispatch(failurePriceStrategyDelete(error));
        showErrorAlert(error?.message || 'Failed to delete price strategy');
      });
  };
};

///////// Assign Merchants to Price Strategy //////////
export const AssignMerchantsToStrategy = (id, merchantIds, callback) => {
  return (dispatch) => {
    dispatch(requestAssignMerchants());
    requestApi
      .put(`${PRICE_STRATEGY}/${id}/assign-merchants`, { merchantIds })
      .then((response) => {
        dispatch(responseAssignMerchants());
        if (callback) callback(response?.data || response);
      })
      .catch((error) => {
        dispatch(failureAssignMerchants(error?.message));
        showErrorAlert(error?.message || 'Failed to assign merchants');
      });
  };
};

///////// Sync Price Strategy Merchants //////////
export const SyncPriceStrategyMerchants = (callback) => {
  return (dispatch) => {
    dispatch(requestPriceStrategySync());
    requestApi
      .post(PRICE_STRATEGY_MIGRATE_MERCHANTS)
      .then((response) => {
        dispatch(responsePriceStrategySync(response));
        showSuccessAlert(
          response?.message || 'Price strategy merchant sync completed',
        );
        if (callback) callback();
      })
      .catch((error) => {
        dispatch(failurePriceStrategySync(error));
        showErrorAlert(error?.message || 'Failed to sync price strategy data');
      });
  };
};
